/**
 * Track Gtag event
 * @param {String} action
 * @param {String} value
 * @param {String} items
 * @param {String} currency
 */
const trackGtagEvent = (action, value, items, currency) => {
  window.gtag("event", action, {
    currency: currency || "GBP",
    value,
    items,
  })
}

export default trackGtagEvent
